export function CircleIconNew({ width = 132, height = 132 }) {
  return (
    <svg width={width} height={height} viewBox='0 0 132 132' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_i_529_1009)'>
        <circle cx='66' cy='66' r='60' stroke='#F5F7F9' strokeWidth='12' />
      </g>
      <defs>
        <filter id='filter0_i_529_1009' x='0' y='0' width='135' height='132' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx='3' />
          <feGaussianBlur stdDeviation='2.5' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_529_1009' />
        </filter>
      </defs>
    </svg>
  );
}
